import React, { useState } from "react";
import styles from "../TabSection/TabSection.module.css";
import AnimatedBtn from "../../AnimatedBtn/AnimatedBtn";

const TabSection = ({ featureTab }) => {
  const [activeTab, setActiveTab] = useState(0);
  const tabData = (featureTab?.tabs || []).map((t) => ({
    title: t?.title || "",
    heading: t?.heading || "",
    features: (t?.features || []).map((f) => ({
      icon: f?.icon?.src || "",
      text: f?.text || "",
      subtext: f?.subtext || "",
    })),
    buttonText: t?.buttonText || "Get Started for FREE",
    img: t?.img?.src || "",
    ellips1: t?.ellips1?.src || "",
  }));

  return (
    <div className={styles.tabsWrapper}>
      <div className={styles.tabNav}>
        {tabData.map((tab, index) => (
          <button
            key={index}
            className={`${styles.tabButton} ${
              activeTab === index ? styles.active : ""
            }`}
            onClick={() => setActiveTab(index)}
          >
            {tab.title}
          </button>
        ))}
      </div>

      <div className={styles.tabContent}>
        {/* Left Side */}
        <div className={styles.left}>
          <h2>{tabData[activeTab].heading}</h2>
          <div className={styles.features}>
            {tabData[activeTab].features.map((f, i) => (
              <div key={i} className={styles.featureItem}>
                <span className={styles.icon}>
                  <img src={f.icon} alt="icon" />
                </span>
                <div className={styles.textDiv}>
                  <span className={styles.text}>{f.text}</span>
                  <span className={styles.subtext}>{f.subtext}</span>
                </div>
              </div>
            ))}
          </div>

          <div className={styles.discoverDiv}>
            <div
              className={styles.demoBtn}
              onClick={() =>
                window.open(
                  "https://app.rxpt.ai/",
                  "_blank",
                  "noopener,noreferrer"
                )
              }
            >
              <AnimatedBtn text="Get Started for FREE" />
            </div>
          </div>
        </div>


        {/* Right Side */}
        <div className={styles.right}>
          <div className={styles.imgDiv}>
            <img src={tabData[activeTab].img} alt={tabData[activeTab].title} />
          </div>

          <div className={styles.EllopsDiv}>
            <img
              className={styles.EllipseImg1}
              src={tabData[activeTab].ellips1}
              alt="ellips3"
            />
          </div>
        </div>
      </div>
    </div>
  );
};


export default TabSection;
